import {Power} from '../../../Domain/Power';
import {round} from './Internal/round';

export function formatPower(power: Power | null): {formatted: string; unit?: string} {
    if (power === null) {
        return {formatted: '-'};
    }
    return {formatted: round(power.watts, 0), unit: 'W'};
}

export function formatAveragePower(power: Power | null): {formatted: string; unit?: string} {
    if (power === null) {
        return {formatted: '-'};
    }
    return {formatted: round(power.watts, 2), unit: 'W'};
}
